module.exports = __webpack_public_path__ + "img/account_circle.15c0aaca.svg";